import RegisterContent from "../../components/UserAccess/Register/RegisterContent";

const RegisterPage = () => {
  return (
    <>
      <RegisterContent />
    </>
  );
};

export default RegisterPage;
